// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/picker-view/style/index.less
// module id = 163
// module chunks = 0